import { render } from "./rental-report.vue?vue&type=template&id=bcc1bffa"
import script from "./rental-report.vue?vue&type=script&lang=js"
export * from "./rental-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__